import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HandRaiseIcon, LoudSpeakerIcon } from '@getgo/chameleon-icons/react';
import { Tooltip } from '@getgo/chameleon-material-ui';
import Typography from "../Typography";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WLBType } from '../../state/wlb/types';
import MessageTooltip from '../MessageTooltip';
import WLBNotification from './WLBNotification';
import classes from './WLBNotifications.module.scss';
const wlbIcons = {
    [WLBType.BARGE]: () => (_jsx(LoudSpeakerIcon, {}, void 0)),
    [WLBType.WHISPER]: () => (_jsx(HandRaiseIcon, {}, void 0)),
};
const WLB_LOCAL_STORAGE_KEY_PREFIX = 'agent-wlb';
const WLBNotifications = ({ notifications }) => {
    const [firstWLB, setFirstWLB] = useState(null);
    const { t } = useTranslation();
    const handleClick = (type) => {
        localStorage.setItem(`${WLB_LOCAL_STORAGE_KEY_PREFIX}-${type}`, true.toString());
        setFirstWLB(null);
    };
    const getMessageText = (notification) => {
        let text;
        if (notification.type === WLBType.BARGE) {
            text = (_jsxs(_Fragment, { children: [_jsx("h3", Object.assign({ className: classes.title }, { children: t('Barged') }), void 0), _jsx(Typography, { children: t('{{firstName}} can speak to all parties on the call.', {
                            firstName: notification.users[0].firstName,
                        }) }, void 0), _jsx("a", Object.assign({ className: classes.confirm, onClick: () => handleClick(notification.type) }, { children: t('OK') }), void 0)] }, void 0));
        }
        else {
            text = (_jsxs(_Fragment, { children: [_jsx("h3", Object.assign({ className: classes.title }, { children: t('Whispering') }), void 0), _jsxs(Typography, { children: [t('{{firstName}} can speak to you without being heard by others on the call.', {
                                firstName: notification.users[0].firstName,
                            }), _jsx("br", {}, void 0), _jsx("strong", { children: t('You will still be heard by everyone on the call.') }, void 0)] }, void 0), _jsx("a", Object.assign({ className: classes.confirm, onClick: () => handleClick(notification.type) }, { children: t("Don't show this again") }), void 0)] }, void 0));
        }
        return text;
    };
    const sortedNotifications = (notifications || [])
        .slice()
        .sort((a, b) => a.type - b.type)
        .filter(a => a.type !== WLBType.SPY);
    useEffect(() => {
        (notifications || [])
            .filter(a => a.type !== WLBType.SPY)
            .forEach(notification => {
            const firstTime = !localStorage.getItem(`${WLB_LOCAL_STORAGE_KEY_PREFIX}-${notification.type}`);
            if (firstTime) {
                setFirstWLB(notification.type);
            }
        });
    }, [notifications]);
    const NotificationTooltip = firstWLB ? MessageTooltip : Tooltip;
    return (_jsx("div", Object.assign({ className: classes.notifications }, { children: sortedNotifications.map(notification => firstWLB ? (_jsx(NotificationTooltip, Object.assign({ id: `wlb-notification-tooltip-${notification.type.toString()}`, open: firstWLB === notification.type ? true : undefined, arrow: firstWLB === notification.type, title: firstWLB === notification.type && getMessageText(notification), placement: "top" }, { children: _jsx("div", { children: _jsx(WLBNotification, { users: notification.users, type: notification.type, icon: wlbIcons[notification.type] }, void 0) }, void 0) }), notification.type)) : (_jsx(WLBNotification, { users: notification.users, type: notification.type, icon: wlbIcons[notification.type] }, notification.type))) }), void 0));
};
export default WLBNotifications;
//# sourceMappingURL=WLBNotifications.js.map